import { Component } from '@angular/core';

@Component({ template: '', standalone: true, selector: 'bar-empty' })
export class BarEmptyComponent {}
